import { Tag } from "antd";

// Acepta los mismos nombres de color que se usaban con antd (success/error/
// warning/processing/default, o green/red/blue/etc.), o un hex directo.
const COLOR_MAP = {
  success: "success",
  green: "success",
  error: "error",
  red: "error",
  warning: "warning",
  orange: "orange",
  gold: "gold",
  yellow: "gold",
  processing: "processing",
  blue: "blue",
  info: "blue",
  cyan: "cyan",
  default: "default",
  gray: "default",
  grey: "default",
  purple: "purple",
};

export default function DataBadge({ color = "default", children, className = "", pill = false, ...rest }) {
  const isHex = color?.startsWith?.("#");
  const tagColor = isHex ? undefined : (COLOR_MAP[color] || color || "default");
  const style = isHex
    ? { backgroundColor: `${color}26`, color, borderColor: `${color}66`, ...rest.style }
    : rest.style;

  return (
    <Tag
      color={tagColor}
      className={`${pill ? "data-badge-pill" : ""} ${className}`}
      {...rest}
      style={style}
    >
      {isHex && (
        <span
          style={{
            display: "inline-block",
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: color,
            marginRight: 6,
          }}
        />
      )}
      {children}
    </Tag>
  );
}
